// Copyright (c) Docugami, Inc. All rights reserved.

export class DgPrototypeNumbering
{
    static abstractNumMarkup: any|null = {

    "circle":
`<w:abstractNum w:abstractNumId='0' xmlns:w='http://schemas.openxmlformats.org/wordprocessingml/2006/main'>
  <w:nsid w:val='3C681AF8'/>
  <w:multiLevelType w:val='hybridMultilevel'/>
  <w:tmpl w:val='FAC0221C'/>
  <w:lvl w:ilvl='0' w:tplc='04090001'>
    <w:start w:val='1'/>
    <w:numFmt w:val='bullet'/>
    <w:lvlText w:val=''/>
    <w:lvlJc w:val='left'/>
    <w:pPr>
    <w:ind w:left='822' w:hanging='720'/>
    </w:pPr>
    <w:rPr>
    <w:rFonts w:ascii='Symbol' w:hAnsi='Symbol' w:hint='default'/>
    <w:b w:val='0'/>
    <w:bCs w:val='0'/>
    <w:i w:val='0'/>
    <w:iCs w:val='0'/>
    <w:spacing w:val='-2'/>
    <w:w w:val='100'/>
    <w:sz w:val='24'/>
    <w:szCs w:val='24'/>
    </w:rPr>
  </w:lvl>
  <w:lvl w:ilvl='1' w:tplc='FFFFFFFF'>
    <w:numFmt w:val='bullet'/>
    <w:lvlText w:val='•'/>
    <w:lvlJc w:val='left'/>
    <w:pPr>
    <w:ind w:left='1712' w:hanging='720'/>
    </w:pPr>
    <w:rPr>
    <w:rFonts w:hint='default'/>
    </w:rPr>
  </w:lvl>
  <w:lvl w:ilvl='2' w:tplc='FFFFFFFF'>
    <w:numFmt w:val='bullet'/>
    <w:lvlText w:val='•'/>
    <w:lvlJc w:val='left'/>
    <w:pPr>
    <w:ind w:left='2604' w:hanging='720'/>
    </w:pPr>
    <w:rPr>
    <w:rFonts w:hint='default'/>
    </w:rPr>
  </w:lvl>
  <w:lvl w:ilvl='3' w:tplc='FFFFFFFF'>
    <w:numFmt w:val='bullet'/>
    <w:lvlText w:val='•'/>
    <w:lvlJc w:val='left'/>
    <w:pPr>
    <w:ind w:left='3496' w:hanging='720'/>
    </w:pPr>
    <w:rPr>
    <w:rFonts w:hint='default'/>
    </w:rPr>
  </w:lvl>
  <w:lvl w:ilvl='4' w:tplc='FFFFFFFF'>
    <w:numFmt w:val='bullet'/>
    <w:lvlText w:val='•'/>
    <w:lvlJc w:val='left'/>
    <w:pPr>
    <w:ind w:left='4388' w:hanging='720'/>
    </w:pPr>
    <w:rPr>
    <w:rFonts w:hint='default'/>
    </w:rPr>
  </w:lvl>
  <w:lvl w:ilvl='5' w:tplc='FFFFFFFF'>
    <w:numFmt w:val='bullet'/>
    <w:lvlText w:val='•'/>
    <w:lvlJc w:val='left'/>
    <w:pPr>
    <w:ind w:left='5280' w:hanging='720'/>
    </w:pPr>
    <w:rPr>
    <w:rFonts w:hint='default'/>
    </w:rPr>
  </w:lvl>
  <w:lvl w:ilvl='6' w:tplc='FFFFFFFF'>
    <w:numFmt w:val='bullet'/>
    <w:lvlText w:val='•'/>
    <w:lvlJc w:val='left'/>
    <w:pPr>
    <w:ind w:left='6172' w:hanging='720'/>
    </w:pPr>
    <w:rPr>
    <w:rFonts w:hint='default'/>
    </w:rPr>
  </w:lvl>
  <w:lvl w:ilvl='7' w:tplc='FFFFFFFF'>
    <w:numFmt w:val='bullet'/>
    <w:lvlText w:val='•'/>
    <w:lvlJc w:val='left'/>
    <w:pPr>
    <w:ind w:left='7064' w:hanging='720'/>
    </w:pPr>
    <w:rPr>
    <w:rFonts w:hint='default'/>
    </w:rPr>
  </w:lvl>
  <w:lvl w:ilvl='8' w:tplc='FFFFFFFF'>
    <w:numFmt w:val='bullet'/>
    <w:lvlText w:val='•'/>
    <w:lvlJc w:val='left'/>
    <w:pPr>
    <w:ind w:left='7956' w:hanging='720'/>
    </w:pPr>
    <w:rPr>
    <w:rFonts w:hint='default'/>
    </w:rPr>
  </w:lvl>
  </w:abstractNum>`,
    "decimal":
`<w:abstractNum w:abstractNumId='0' xmlns:w='http://schemas.openxmlformats.org/wordprocessingml/2006/main'>
  <w:nsid w:val='29B3631B'/>
  <w:multiLevelType w:val='hybridMultilevel'/>
  <w:tmpl w:val='FF1A4958'/>
  <w:lvl w:ilvl='0' w:tplc='0409000F'>
    <w:start w:val='1'/>
    <w:numFmt w:val='decimal'/>
    <w:lvlText w:val='%1.'/>
    <w:lvlJc w:val='left'/>
    <w:pPr>
      <w:ind w:left='822' w:hanging='720'/>
    </w:pPr>
    <w:rPr>
      <w:rFonts w:hint='default'/>
      <w:b w:val='0'/>
      <w:bCs w:val='0'/>
      <w:i w:val='0'/>
      <w:iCs w:val='0'/>
      <w:spacing w:val='-2'/>
      <w:w w:val='100'/>
      <w:sz w:val='24'/>
      <w:szCs w:val='24'/>
    </w:rPr>
  </w:lvl>
  <w:lvl w:ilvl='1' w:tplc='FFFFFFFF'>
    <w:numFmt w:val='bullet'/>
    <w:lvlText w:val='•'/>
    <w:lvlJc w:val='left'/>
    <w:pPr>
      <w:ind w:left='1712' w:hanging='720'/>
    </w:pPr>
    <w:rPr>
      <w:rFonts w:hint='default'/>
    </w:rPr>
  </w:lvl>
  <w:lvl w:ilvl='2' w:tplc='FFFFFFFF'>
    <w:numFmt w:val='bullet'/>
    <w:lvlText w:val='•'/>
    <w:lvlJc w:val='left'/>
    <w:pPr>
      <w:ind w:left='2604' w:hanging='720'/>
    </w:pPr>
    <w:rPr>
      <w:rFonts w:hint='default'/>
    </w:rPr>
  </w:lvl>
  <w:lvl w:ilvl='3' w:tplc='FFFFFFFF'>
    <w:numFmt w:val='bullet'/>
    <w:lvlText w:val='•'/>
    <w:lvlJc w:val='left'/>
    <w:pPr>
      <w:ind w:left='3496' w:hanging='720'/>
    </w:pPr>
    <w:rPr>
      <w:rFonts w:hint='default'/>
    </w:rPr>
  </w:lvl>
  <w:lvl w:ilvl='4' w:tplc='FFFFFFFF'>
    <w:numFmt w:val='bullet'/>
    <w:lvlText w:val='•'/>
    <w:lvlJc w:val='left'/>
    <w:pPr>
      <w:ind w:left='4388' w:hanging='720'/>
    </w:pPr>
    <w:rPr>
      <w:rFonts w:hint='default'/>
    </w:rPr>
  </w:lvl>
  <w:lvl w:ilvl='5' w:tplc='FFFFFFFF'>
    <w:numFmt w:val='bullet'/>
    <w:lvlText w:val='•'/>
    <w:lvlJc w:val='left'/>
    <w:pPr>
      <w:ind w:left='5280' w:hanging='720'/>
    </w:pPr>
    <w:rPr>
      <w:rFonts w:hint='default'/>
    </w:rPr>
  </w:lvl>
  <w:lvl w:ilvl='6' w:tplc='FFFFFFFF'>
    <w:numFmt w:val='bullet'/>
    <w:lvlText w:val='•'/>
    <w:lvlJc w:val='left'/>
    <w:pPr>
      <w:ind w:left='6172' w:hanging='720'/>
    </w:pPr>
    <w:rPr>
      <w:rFonts w:hint='default'/>
    </w:rPr>
  </w:lvl>
  <w:lvl w:ilvl='7' w:tplc='FFFFFFFF'>
    <w:numFmt w:val='bullet'/>
    <w:lvlText w:val='•'/>
    <w:lvlJc w:val='left'/>
    <w:pPr>
      <w:ind w:left='7064' w:hanging='720'/>
    </w:pPr>
    <w:rPr>
      <w:rFonts w:hint='default'/>
    </w:rPr>
  </w:lvl>
  <w:lvl w:ilvl='8' w:tplc='FFFFFFFF'>
    <w:numFmt w:val='bullet'/>
    <w:lvlText w:val='•'/>
    <w:lvlJc w:val='left'/>
    <w:pPr>
      <w:ind w:left='7956' w:hanging='720'/>
    </w:pPr>
    <w:rPr>
      <w:rFonts w:hint='default'/>
    </w:rPr>
  </w:lvl>
</w:abstractNum>"`,
    "upper-alpha":
`<w:abstractNum w:abstractNumId='0' xmlns:w='http://schemas.openxmlformats.org/wordprocessingml/2006/main'>
	<w:nsid w:val='2DD20167'/>
	<w:multiLevelType w:val='hybridMultilevel'/>
	<w:tmpl w:val='1792AE86'/>
	<w:lvl w:ilvl='0' w:tplc='DAFEEE2C'>
		<w:start w:val='1'/>
		<w:numFmt w:val='upperLetter'/>
		<w:lvlText w:val='(%1)'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='822' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:ascii='Times New Roman' w:eastAsia='Times New Roman' w:hAnsi='Times New Roman' w:cs='Times New Roman' w:hint='default'/>
			<w:b w:val='0'/>
			<w:bCs w:val='0'/>
			<w:i w:val='0'/>
			<w:iCs w:val='0'/>
			<w:spacing w:val='-2'/>
			<w:w w:val='100'/>
			<w:sz w:val='24'/>
			<w:szCs w:val='24'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='1' w:tplc='B3E84794'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='1712' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='2' w:tplc='4AB8F164'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='2604' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='3' w:tplc='30F45DD0'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='3496' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='4' w:tplc='5E22D486'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='4388' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='5' w:tplc='D2B04628'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='5280' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='6' w:tplc='C7E40EE2'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='6172' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='7' w:tplc='62FCC3E2'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='7064' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='8' w:tplc='5436F4A8'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='7956' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
</w:abstractNum>`,
    "lower-alpha":
`<w:abstractNum w:abstractNumId='0' xmlns:w='http://schemas.openxmlformats.org/wordprocessingml/2006/main'>
	<w:nsid w:val='1E6B2C49'/>
	<w:multiLevelType w:val='hybridMultilevel'/>
	<w:tmpl w:val='ED5CA83C'/>
	<w:lvl w:ilvl='0' w:tplc='04090017'>
		<w:start w:val='1'/>
		<w:numFmt w:val='lowerLetter'/>
		<w:lvlText w:val='%1)'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='822' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
			<w:b w:val='0'/>
			<w:bCs w:val='0'/>
			<w:i w:val='0'/>
			<w:iCs w:val='0'/>
			<w:spacing w:val='-2'/>
			<w:w w:val='100'/>
			<w:sz w:val='24'/>
			<w:szCs w:val='24'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='1' w:tplc='FFFFFFFF'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='1712' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='2' w:tplc='FFFFFFFF'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='2604' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='3' w:tplc='FFFFFFFF'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='3496' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='4' w:tplc='FFFFFFFF'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='4388' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='5' w:tplc='FFFFFFFF'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='5280' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='6' w:tplc='FFFFFFFF'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='6172' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='7' w:tplc='FFFFFFFF'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='7064' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='8' w:tplc='FFFFFFFF'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='7956' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
</w:abstractNum>`,
    "upper-roman":
`<w:abstractNum w:abstractNumId='0' xmlns:w='http://schemas.openxmlformats.org/wordprocessingml/2006/main'>
	<w:nsid w:val='5298898F'/>
	<w:multiLevelType w:val='hybridMultilevel'/>
	<w:tmpl w:val='F8A43874'/>
	<w:lvl w:ilvl='0' w:tplc='04090013'>
		<w:start w:val='1'/>
		<w:numFmt w:val='upperRoman'/>
		<w:lvlText w:val='%1.'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='822' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
			<w:b w:val='0'/>
			<w:bCs w:val='0'/>
			<w:i w:val='0'/>
			<w:iCs w:val='0'/>
			<w:spacing w:val='-2'/>
			<w:w w:val='100'/>
			<w:sz w:val='24'/>
			<w:szCs w:val='24'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='1' w:tplc='FFFFFFFF'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='1712' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='2' w:tplc='FFFFFFFF'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='2604' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='3' w:tplc='FFFFFFFF'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='3496' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='4' w:tplc='FFFFFFFF'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='4388' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='5' w:tplc='FFFFFFFF'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='5280' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='6' w:tplc='FFFFFFFF'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='6172' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='7' w:tplc='FFFFFFFF'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='7064' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='8' w:tplc='FFFFFFFF'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='7956' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
</w:abstractNum>`,
    "lower-roman":
`<w:abstractNum w:abstractNumId='0' xmlns:w='http://schemas.openxmlformats.org/wordprocessingml/2006/main'>
	<w:nsid w:val='7A474CA0'/>
	<w:multiLevelType w:val='hybridMultilevel'/>
	<w:tmpl w:val='CA64F9A6'/>
	<w:lvl w:ilvl='0' w:tplc='0409001B'>
		<w:start w:val='1'/>
		<w:numFmt w:val='lowerRoman'/>
		<w:lvlText w:val='%1.'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='822' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
			<w:b w:val='0'/>
			<w:bCs w:val='0'/>
			<w:i w:val='0'/>
			<w:iCs w:val='0'/>
			<w:spacing w:val='-2'/>
			<w:w w:val='100'/>
			<w:sz w:val='24'/>
			<w:szCs w:val='24'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='1' w:tplc='FFFFFFFF'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='1712' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='2' w:tplc='FFFFFFFF'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='2604' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='3' w:tplc='FFFFFFFF'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='3496' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='4' w:tplc='FFFFFFFF'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='4388' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='5' w:tplc='FFFFFFFF'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='5280' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='6' w:tplc='FFFFFFFF'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='6172' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='7' w:tplc='FFFFFFFF'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='7064' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
	<w:lvl w:ilvl='8' w:tplc='FFFFFFFF'>
		<w:numFmt w:val='bullet'/>
		<w:lvlText w:val='•'/>
		<w:lvlJc w:val='left'/>
		<w:pPr>
			<w:ind w:left='7956' w:hanging='720'/>
		</w:pPr>
		<w:rPr>
			<w:rFonts w:hint='default'/>
		</w:rPr>
	</w:lvl>
</w:abstractNum>`
    };
}
